import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Input, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { Link, useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function Ventures() {
  const [Actin, setActin] = useState([])
  const history = useHistory()

  const gets = localStorage.getItem("authUser")
  const data = JSON.parse(gets)
  const datas = data.token
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)
  const [Searchs, setSearchs] = useState([])

  useEffect(() => {
    GetProducts()
    datass()
  }, [])

  const GetProducts = () => {
    const token = datas

    axios
      .post(
        URLS.GetListing,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.services)
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const lists = Actin.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Actin.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const Actinid = data => {
    sessionStorage.setItem("ListingId", data._id)
    history.push("/EditListing")
  }

  const datass = () => {
    const location = sessionStorage.getItem("tost")
    if (location !== "") {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    const token = datas

    axios
      .post(
        URLS.GetListingSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.services)
      })
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteBanner(data)
    }
  }

  const deleteAPI = "v1/a2zsolutionsapi/admin/service/deleteservice/"

  const DeleteBanner = data => {
    const token = datas
    const remid = data._id

    axios
      .delete(URLS.Base + deleteAPI + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetProducts()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const Actinid1 = data => {
    sessionStorage.setItem("ListingId", data._id)
    history.push("/ViewListing")
  }

  const Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home " breadcrumbItem="Listing" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      {Roles?.NewListingAdd === true || Roles?.accessAll === true ? (
                        <Link to="/AddListing">
                          <Button color="primary">
                            New Listing <i className="bx bx-plus-circle"></i>
                          </Button>
                        </Link>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          p placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4">
                      <thead>
                        <tr className="text-center">
                          <th>Sl.No</th>
                          <th>Listing Code</th>
                          <th>Business Image</th>
                          <th>Category Name</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <td>{(pageNumber - 1) * 5 + key + 6}</td>
                            <td>{data.listingCode}</td>
                            <td>
                              <img
                                src={URLS.Base + data.businessLogo[0]}
                                style={{ width: "80px" }}
                                alt="Business Logo"
                              />
                            </td>
                            <td>{data.categoryName}</td>
                            <td>{data.name}</td>
                            <td>{data.contact}</td>
                            <td>{data.email}</td>
                            <td>
                              {Roles?.NewListingEdit === true || Roles?.accessAll === true ? (
                                <Button
                                  onClick={() => {
                                    Actinid(data)
                                  }}
                                  size="sm"
                                  className="m-1"
                                  color="success"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-edit m-1"></i>
                                      Edit
                                    </small>
                                  </div>
                                </Button>
                              ) : (
                                ""
                              )}
                              <Button
                                onClick={() => {
                                  Actinid1(data)
                                }}
                                size="sm"
                                className="m-1"
                                color="info"
                              >
                                <div className="d-flex">
                                  <small>
                                    <i className="fas fa-eye"></i> View
                                  </small>
                                </div>
                              </Button>
                              {Roles?.NewListingDelete === true || Roles?.accessAll === true ? (
                                <Button
                                  onClick={() => {
                                    manageDelete(data)
                                  }}
                                  size="sm"
                                  className="m-1"
                                  color="danger"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-trash m-1"></i>
                                      Delete
                                    </small>
                                  </div>
                                </Button>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
